import * as SsrList from './List/SsrList.css';
import * as Ssr from './Ssr.css';
import * as SsrModal from './SsrModal/SsrModal.css';
export default {
    SsrList: SsrList,
    Ssr: Ssr,
    SsrModal: SsrModal
};
